export const popularDomain = [
  'aol.com',
  'att.net',
  'bellsouth.net',
  'charter.net',
  'comcast.net',
  'cox.net',
  'gmail.com',
  'hotmail.com',
  'icloud.com',
  'live.com',
  'mac.com',
  'me.com',
  'msn.com',
  'outlook.com',
  'sbcglobal.net',
  'verizon.net',
  'yahoo.com',
  'ymail.com'
];

export const tableDefaultProps = {
  defaultPageSize: 15,
  pageSizeOptions: ['15', '30', '50', '100'],
  showSizeChanger: true
};

export const projectTableDefaultProps = {
  defaultPageSize: 10,
  pageSizeOptions: ['10', '20', '50', '100'],
  showSizeChanger: true
};

export const accountTablesDefaultProps = {
  defaultPageSize: 6,
  pageSizeOptions: ['6', '10', '20', '50', '100'],
  showSizeChanger: true
};

export const paymentsTabDefaultPageSize = 15;

export const DESCENDING_SORT_PREFIX = 'reverse:';

export const SortDirection = {
  ascend: 'asc',
  descend: 'desc'
} as const;

export const DefaultSortTable = {
  ascend: 'ascend',
  descend: 'descend'
} as const;
